import { Controller } from '@hotwired/stimulus';
import { agencyFees, agencyFeesRateLabel } from '../../shared/helpers/agencyFeesHelper';

export default class extends Controller {
  static targets = ['estimationStep',
                    'resultStep',
                    'submit',
                    'agencyFees',
                    'netSellerWithClassicAgency',
                    'netSellerWithHosman',
                    'agencyFeesDiff',
                    'priceRef',
                    'firstCategory',
                    'secondCategory',
                    'thirdCategory',
                    'fourthCategory',
                    'input',
                    'category',
                    'yourCommission',
                    'changeCriteria',
                    'container',
                    'feesShow'];

  static values = { defaultRegion: String }

  connect = () => {
    this.submitTarget.disabled = true
    this.resetModule()
  }

  handleChange = (e) => {
    const target = e.currentTarget

    if (target.name === 'region') this.setRegion(target.value)
    if (target.name === 'price') this.price = target.value
    if (this.parisRegion !== null && this.price !== null) this.submitTarget.disabled = false
  }

  setRegion = (region) => {
    this.feesRegion = region || null;
    this.parisRegion = region ? region.toLowerCase() === 'paris' : null
    this.region = region ? region.toLowerCase() : null
  }

  handleSubmit = () => {
    this.handleStepsDisplay();
    this.handleAgencyFees();
    this.handleHTMLContent();
    this.handleHTMLDisplay();
    this.pushDataLayer();
    this.scrollToAnchor();
  }

  resetModule = () => {
    this.setRegion(this.defaultRegionValue);
    this.price = null;
    this.submitTarget.disabled = true

    this.estimationStepTarget.classList.remove('hidden')
    this.resultStepTarget.classList.add('hidden')

    this.categoryTargets.map(category => {
      if (!category.classList.contains('hidden')) category.classList.add('hidden')
    })

    this.inputTargets.map(input => {
      if (input.name === 'propertyKind') input.checked = false
      else input.value = ''
    })

    this.feesShowTargets.map(feesShowDiv => {
      feesShowDiv.classList.remove('hidden');
    })

    this.resetSlimSelect();
    this.scrollToAnchor();
  }

  resetSlimSelect = () => {
    const inputs = this.inputTargets.filter(input => input.type === 'select-one')
    inputs.forEach(input => {
      const slimSelectController = this.application.getControllerForElementAndIdentifier(
        input,
        'application--slim-select'
      );
      if (slimSelectController) {
        slimSelectController.destroy()
        slimSelectController.connect()
      }
    })
  }

  handleStepsDisplay = () => {
    this.estimationStepTarget.classList.add('hidden')
    this.resultStepTarget.classList.remove('hidden')
  }

  pushDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'submit_tariff_estimation',
      'region': this.region,
    })
  }

  scrollToAnchor() {
    const anchor = document.querySelector('#title-anchor')
    if (!anchor) return;

    const offset = 100;
    const elementPosition = anchor.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  handleAgencyFees = () => {
    this.agencyFees = agencyFees(
      this.feesRegion,
      this.price,
      false
    );
  }

  handleHTMLContent = () => {
    this.classicAgencyRate = Number(this.price) < 150_000 ? 6.0 : 5.78
    this.feesWithClassicAgency = Number(this.price) * (this.classicAgencyRate / 100)

    this.agencyFeesTarget.innerHTML = agencyFeesRateLabel(this.feesRegion, this.price) || this.formatPriceHelper(this.agencyFees)

    this.netSellerWithHosmanTarget.innerHTML = this.formatPriceHelper(Number(this.price) - Number(this.agencyFees))
    this.netSellerWithClassicAgencyTarget.innerHTML = this.formatPriceHelper(Number(this.price) - Number(this.feesWithClassicAgency))

    if ((this.feesWithClassicAgency - this.agencyFees) < 1000) this.feesShowTargets.map(feesShowDiv => {
      feesShowDiv.classList.add('hidden');
    })

    this.agencyFeesDiffTarget.innerHTML = this.formatPriceHelper(this.feesWithClassicAgency - this.agencyFees)
    this.priceRefTarget.innerHTML = this.formatPriceHelper(Number(this.price))
  }

  handleHTMLDisplay = () => {
    // 'Strong points' trad condition according to hosman prices steps
    if (Number(this.price) <= 200000) this.firstCategoryTarget.classList.toggle('hidden')
    else if (Number(this.price) <= process.env.PREMIUM_START_VALUE_REGIONS) this.secondCategoryTarget.classList.toggle('hidden')
    else if (Number(this.price) <= process.env.PREMIUM_START_VALUE_PARIS) this.thirdCategoryTarget.classList.toggle('hidden')
    else this.fourthCategoryTarget.classList.toggle('hidden')
  }

  formatPriceHelper = (price) => {
    const options = { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 };
    const priceString = price.toLocaleString('fr-FR', options);
    return priceString;
  }
}
